import React, {Component} from "react";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import MoveTitleGuarantee from "./moveTitleGuaranteeView";
import {MoveGuaranteeService} from "../../../service/controlPanel/MoveGuaranteeService";
import {getReadOnlyGuarantee, getReadOnlyReward, getReadOnlyTitles} from "../util/ControlPanelUtil";
import {Growl} from "primereact/growl";
import {Button} from "primereact/button";
import NumberFormat from "react-number-format";

export default class MoveTitleGuaranteeContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();
        this.moveGuaranteeService = new MoveGuaranteeService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getAction = this.getAction.bind(this);
        this.getLoan = this.getLoan.bind(this);
        this.getIndevalAccounts = this.getIndevalAccounts.bind(this);
        this.getGuaranteeInFlow = this.getGuaranteeInFlow.bind(this);
        this.getReadOnlyReward = this.getReadOnlyReward.bind(this);
        this.getReadOnlyTitles = this.getReadOnlyTitles.bind(this);
        this.getReadOnlyGuarantee = this.getReadOnlyGuarantee.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.handleRefuse = this.handleRefuse.bind(this);
        this.titleEditor = this.titleEditor.bind(this);
        this.guaranteeEditor = this.guaranteeEditor.bind(this);
        this.rewardEditor = this.rewardEditor.bind(this);
        this.onEditorGuaranteeValueChange = this.onEditorGuaranteeValueChange.bind(this);
        this.onEditorTitleValueChange = this.onEditorTitleValueChange.bind(this);
        this.onEditorRewardValueChange = this.onEditorRewardValueChange.bind(this);
        this.getValidFolio = this.getValidFolio.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.showRejectDialog = this.showRejectDialog.bind(this);
        this.saveMessage = this.saveMessage.bind(this);

        this.state = {
            isLoading: true,
            displayDialog: false,
            loanId: this.props.location.state.folio,
            flowId: this.props.location.state.flowId,
            status: this.props.location.state.status,
            action: this.getAction(this.props.location.state.status),
            loan: [],
            indevalAccount: [],
            guaranteeInFlow: [],
            readOnlyTitles: this.getReadOnlyTitles(this.props.location.state.status),
            readOnlyGuarantee: this.getReadOnlyGuarantee(this.props.location.state.status),
            readOnlyReward: this.getReadOnlyReward(this.props.location.state.flowId, this.props.location.state.status),
            rejectMessage: '',
        };

        this.getLoan(this.props.location.state.folio);
        this.getIndevalAccounts(this.props.location.state.folio);
        this.getGuaranteeInFlow(this.props.location.state.folio);
    }

    getReadOnlyReward(flowId, status) {
        return getReadOnlyReward(flowId, status);
    }

    getReadOnlyTitles(status) {
        return getReadOnlyTitles(status);
    }

    getReadOnlyGuarantee(status) {
        return getReadOnlyGuarantee(status);
    }

    getLoan(loanId) {
        this.moveGuaranteeService.getTitlesInFlow(loanId)
            .then(response => {

                response.map(
                    (item) => {
                        if (item.folioIndeval === 0) {
                            item.folioIndeval = '';
                        }

                        if (item.folioPremio === 0) {
                            item.folioPremio = '';
                        }
                        return '';
                    });

                this.setState({
                    loan: response
                });
                this.loading(false);
            });
    }

    getIndevalAccounts(loanId) {
        this.loading(true);
        this.moveGuaranteeService.getIndevalAccounts(loanId).then(response => {
            this.setState({
                indevalAccount: response
            });
            this.loading(false);
        });
    }

    getGuaranteeInFlow(loanId) {
        this.loading(true);
        this.moveGuaranteeService.getGuaranteeInFlow(loanId).then(response => {

            response.map(
                (item) => {
                    if (item.folioGarantia === '0') {
                        item.folioGarantia = '';
                    }
                    return '';
                });

            this.setState({
                guaranteeInFlow: response
            });
            this.loading(false);
        });
    }

    getAction(status) {
        let action = '';
        switch (status) {
            case 'TG':
                action = 'Traspaso de Garantías';
                break;
            case 'CoTG':
                action = 'Confirmación de Traspaso de Garantías';
                break;
            case 'RG':
                action = 'Regreso de Garantías';
                break;
            case 'CoRG':
                action = 'Confirmación de Regreso de Garantías';
                break;
            case 'TT':
                action = 'Traspaso de Títulos';
                break;
            case 'CoTT':
                action = 'Confirmación de Traspaso de Títulos';
                break;
            case 'RT':
            case 'V':
            case 'VA':
                action = 'Regreso de Títulos';
                break;
            case 'CoRT':
                action = 'Confirmación de Regreso de Títulos';
                break;
            case 'TP':
                action = 'Traspaso de Premio';
                break;
            case 'CoTP':
                action = 'Confirmación de Traspaso de Premio';
                break;
            default:
                action = '';
                break;
        }
        return action;
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message: message,
        });
    }

    onEditorRewardValueChange(props, value) {
        let reward = [...props.value];

        reward[props.rowIndex][props.field] = value;
        this.setState({loan: reward});
    }

    rewardEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.folioPremio}
            maxLength={18}
            thousandSeparator={false}
            allowNegative={false}
            allowEmptyFormatting={true}
            keyfilter="pint"
            onChange={(e) => this.onEditorRewardValueChange(props, e.target.value)}
        />;
    }

    onEditorTitleValueChange(props, value) {
        let titles = [...props.value];

        titles[props.rowIndex][props.field] = value;
        this.setState({loan: titles});
    }

    titleEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.folioIndeval}
            maxLength={18}
            thousandSeparator={false}
            allowNegative={false}
            allowEmptyFormatting={true}
            keyfilter="pint"
            onChange={(e) => this.onEditorTitleValueChange(props, e.target.value)}
        />;
    }

    onEditorGuaranteeValueChange(props, value) {
        let guarantee = [...props.value];

        guarantee[props.rowIndex][props.field] = value;
        this.setState({guaranteeInFlow: guarantee});
    }

    guaranteeEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.folioGarantia}
            thousandSeparator={false}
            allowNegative={false}
            allowEmptyFormatting={true}
            maxLength={18}
            keyfilter="pint"
            onChange={(e) => this.onEditorGuaranteeValueChange(props, e.target.value)}
        />;
    }

    getValidFolio() {
        let isValid = true;
        switch (this.state.status) {
            case 'TG':
            case 'RG':
                this.state.guaranteeInFlow.map(
                    (item) => {
                        if (item.folioGarantia === undefined || item.folioGarantia * 1 <= 0) {
                            isValid = false
                        }
                        return '';
                    });
                break;
            case 'TT':
            case 'RT':
            case 'V':
            case 'VA':
                if (this.state.loan[0].folioIndeval === undefined || this.state.loan[0].folioIndeval * 1 <= 0) {
                    isValid = false
                }

                if (this.state.status === 'V' || this.state.status === 'VA' || this.state.status === 'TP' || this.state.status === 'RT') {
                    if (this.state.loan[0].folioPremio === undefined || this.state.loan[0].folioPremio * 1 <= 0) {
                        isValid = false
                    }
                }

                break;
            case 'TP':
                if (this.state.loan[0].folioPremio === undefined || this.state.loan[0].folioPremio * 1 <= 0) {
                    isValid = false
                }
                break;
            default:
                isValid = true;
        }
        return isValid;
    }

    handleAgree() {
        let isValidFolio = this.getValidFolio();

        let guaranteeList = [];

        this.state.guaranteeInFlow.map(
            (item) => {
                guaranteeList.push({
                    idEmisora: item.idEmisora,
                    folioGarantia: item.folioGarantia
                });
                return '';
            });


        if (!isValidFolio) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar los folios"});
        } else {
            this.loading(true);

            this.moveGuaranteeService.agree(
                this.state.loanId,
                this.state.flowId,
                this.state.loan[0].folioIndeval,
                this.state.loan[0].folioPremio,
                '',
                this.state.status,
                guaranteeList
            ).then(response => {
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.loading(false);
                    this.handleReturnButton(
                        {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'El préstamo fue avanzado exitosamente',
                        }
                    );
                }
            });
        }
    }

    handleRefuse() {
        if (this.state.rejectMessage === '') {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de poner un mensaje"});
        } else {
            this.moveGuaranteeService.reject(
                this.state.loanId,
                this.state.flowId,
                '',
                this.state.status,
            ).then(response => {
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton(
                        {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'El préstamo fue rechazado exitosamente',
                        }
                    );
                }
            });
        }
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    showRejectDialog() {
        this.setState({
            displayDialog: true,
        });
    }

    saveMessage(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Rechazar</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Guardar" onClick={this.handleRefuse}/>
                </div>
            </div>;

        return <MoveTitleGuarantee
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            loading={this.loading}
            status={this.state.status}
            handleReturnButton={this.handleReturnButton}
            handleAgree={this.handleAgree}
            handleRefuse={this.handleRefuse}
            dialogHeader={dialogHeader}
            displayDialog={this.state.displayDialog}
            onHideDialog={this.onHideDialog}
            showRejectDialog={this.showRejectDialog}
            loanId={this.state.loanId}
            action={this.state.action}
            indevalAccount={this.state.indevalAccount}
            loan={this.state.loan}
            guaranteeInFlow={this.state.guaranteeInFlow}
            hideReward={this.state.readOnlyReward !== undefined}
            titleEditor={this.titleEditor}
            guaranteeEditor={this.guaranteeEditor}
            rewardEditor={this.rewardEditor}
            readOnlyTitles={this.state.readOnlyTitles}
            readOnlyGuarantee={this.state.readOnlyGuarantee}
            readOnlyReward={this.state.readOnlyReward}
            rejectMessage={this.state.rejectMessage}
            saveMessage={this.saveMessage}
        />

    }
}
;